<template>
    <v-dialog v-model="dialog" width="420px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon class="mx-2" color="secondary">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>delete</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="justify-center subtitle-2 pt-6">
                Do you really want to delete the
                <span class="px-2 secondary--text"> {{ spot.name }} </span>
                of the <span class="px-2 secondary--text">{{spot.team?.name}}</span> team?
            </v-card-title>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" 
                    @click="closeDialog">
                    No
                </v-btn>
                <v-btn color="error" text class="text-capitalize" 
                    :disabled="Boolean(error)" 
                    @click="deleteSpot">
                    Yes</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-xs-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'

export default {
    props: ['spot'],
    data() {
        return {
            dialog: false,
            error: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        async deleteSpot() {
            if (this.spot && this.spot.id) {
                const id = this.spot.id
                console.log(this.spot)
                try {
                    await this.$store.dispatch('deleteAllSpot', id);
                }
                catch (error) {
                    console.log(error.message)
                }
            }
        }
    },
    components: { Loader }
}
</script>